import styled from 'styled-components';

export const Wrapper = styled.div`
	margin: 32px auto;

	display: flex;
	flex-direction: column;
	gap: 32px;
`;

export const SectionWrapper = styled.div``;

export const SectionTitle = styled.h2`
	font-size: 32px;
	line-height: 44px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	margin-bottom: 24px;
`;

export const ButtonCenteredWrapper = styled.div`
	display: flex;
	justify-content: center;
`;

export const GuideCardRow = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: 1fr;
	grid-column-gap: 16px;
	grid-row-gap: 16px;

	@media (max-width: 992px) {
		grid-template-columns: 1fr;
		grid-template-rows: repeat(3, 1fr);
	}
`;

export const PrizeSlidesRow = styled.div`
	position: relative;
`;

export const Faq = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;

	@media (max-width: 992px) {
		flex-direction: column;
	}
`;

export const FaqContent = styled.div`
	max-width: 852px;
	width: 100%;

	@media (max-width: 992px) {
		max-width: 100%;
	}
`;

export const FaqCards = styled.div`
	grid-template-columns: repeat(4, 1fr);
`;

export const FaqImageWrapper = styled.div`
	max-width: 615px;
	width: 100%;

	img {
		width: 100%;
	}

	@media (max-width: 992px) {
		width: 375px;
	}
`;
